import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { CandidateService, type InterviewStatus } from '@/services/api';

type GetCandidatesExcelExportParams = {
  interviewsId?: string;
  q?: string;
  ratings?: Array<number>;
  dateFrom?: Date;
  dateTo?: Date;
  status?: Array<InterviewStatus>;
  aiScoreFrom?: number;
  aiScoreTo?: number;
};

export const useExportCandidatesMutation = (
  options?: Partial<
    UseMutationOptions<string, AxiosError, GetCandidatesExcelExportParams>
  >
) => {
  return useMutation<string, AxiosError, GetCandidatesExcelExportParams>({
    mutationFn: (params) => {
      return CandidateService.getCandidatesExcelExport(
        {
          ...params,
          dateFrom: params.dateFrom?.toISOString(),
          dateTo: params.dateTo?.toISOString(),
        },
        options?.axiosRequestConfig
      );
    },
    ...options,
  });
};
